import { useContext, useEffect } from 'react'

import { EventStreamContext, Subscriber } from './EventStreamProvider'

const useEventStream = (
  subscriber?: Subscriber | undefined,
): {
  subscribe: (subscriber: Subscriber) => void
  unsubscribe: (subscriber: Subscriber) => void
} => {
  const eventStream = useContext(EventStreamContext)

  useEffect(() => {
    if (!subscriber) {
      return
    }
    if (!eventStream) {
      console.error('EventStreamContext is not available')
      return
    }
    eventStream.subscribe(subscriber)
    return () => {
      eventStream.unsubscribe(subscriber)
    }
  }, [eventStream, subscriber])

  return {
    subscribe: eventStream.subscribe,
    unsubscribe: eventStream.unsubscribe,
  }
}

export default useEventStream
